export default {
    when() {
        return document.querySelectorAll('.dropdown-toggle').length > 0;
    },

    dropdowns: [],

    mounted() {
        document.querySelectorAll('.dropdown-toggle').forEach((button) => {
            this.dropdowns.push(new Dropdown(button, button.dataset));
        });
    },

    destroy() {
        this.dropdowns.forEach((dropdown) => {
            dropdown.unbind();
        });
    },
};

class Dropdown {
    constructor(button, options = {}) {
        this.button = button;
        this.options = {
            container: '.dropdown-container',
            target: null,
            trigger: 'click',
            ...options,
        };
        this.container = this.button.closest(this.options.container);
        this.dropdown = document.getElementById(this.options.target);
        this.isBusy = false;
        this.isVisible = false;

        if (this.options.trigger === 'click') {
            // @note - prevent barba.js to handle this link
            button.setAttribute('data-barba-prevent', 'self');
        }

        this.bind();
    }

    bind() {
        if (this.options.trigger === 'hover') {
            document.addEventListener('mouseover', (e) => this.handleHover(e), false);
        } else {
            document.addEventListener('click', (e) => this.handleClick(e), false);
            document.addEventListener('mousedown', (e) => this.handleMouseDown(e), false);
            document.addEventListener('mouseup', (e) => this.handleMouseUp(e), false);
        }

        document.addEventListener('focus', (e) => this.handleFocus(e), true);
        document.addEventListener('keydown', (e) => this.handleEscape(e), false);
    }

    handleClick(e) {
        const isWithinBoundaries = e.composedPath().includes(this.button);

        if (isWithinBoundaries) {
            e.preventDefault();
            e.stopImmediatePropagation();

            this.toggle(isWithinBoundaries && !this.isVisible);
        }
    }

    handleEscape(e) {
        if (e.code === 'Escape') {
            this.hide();
        }
    }

    handleFocus(e) {
        if (!this.isBusy) {
            const isWithinBoundaries = e.composedPath().includes(this.dropdown) || e.composedPath().includes(this.button);
            this.toggle(isWithinBoundaries);
        }
    }

    handleFocusOut(e) {
        const links = this.dropdown.querySelectorAll('a');
        const lastElement = links[links.length - 1];

        if (e.target === lastElement) {
            this.hide();
        }
    }

    handleHover(e) {
        if (this.options.trigger === 'hover') {
            const isWithinBoundaries = e.composedPath().includes(this.container) || e.composedPath().includes(this.dropdown) || e.composedPath().includes(this.button);
            this.toggle(isWithinBoundaries);
        }
    }

    handleMouseDown() {
        this.isBusy = true;
    }

    handleMouseUp() {
        this.isBusy = false;
    }

    hide() {
        this.container.classList.remove('open');
        this.button.setAttribute('aria-expended', false);
        this.isVisible = false;
    }

    show() {
        this.container.classList.add('open');
        this.button.setAttribute('aria-expended', true);
        this.isVisible = true;
    }

    toggle(force = null) {
        const condition = force !== null ? force : !this.isVisible;

        if (condition) {
            this.show();
        } else {
            this.hide();
        }
    }

    unbind() {
        if (this.options.trigger === 'hover') {
            document.removeEventListener('mouseover', (e) => this.handleHover(e));
        } else {
            document.removeEventListener('click', (e) => this.handleClick(e));
            document.removeEventListener('mousedown', (e) => this.handleMouseDown(e));
            document.removeEventListener('mouseup', (e) => this.handleMouseUp(e));
        }

        document.removeEventListener('focus', (e) => this.handleFocus(e));
        document.removeEventListener('keydown', (e) => this.handleEscape(e));
    }
}
